export default __webpack_public_path__ + "static/media/no_resultados.67d4cf02.svg";